export default __webpack_public_path__ + "static/media/searchIcon.6cf750b3.svg";